import React from 'react';

import logo from '../../../assets/zeos-ai-blue-logo.png';
import { APP_VERSION } from '../../../configs/AppVersion';

export const DashboardFooter = () => {
  return (
    <div className="bg-white flex items-center justify-between w-full pt-[20px] px-6 pb-2 text-xs">
      <img className="h-8" src={logo} alt="ZEOS-AI logo" />
      <div className="flex">
        <div className="mx-2">ZEOS-AI {APP_VERSION}</div>
        <div className="mx-2">Terms of Use | Privacy Policy</div>
      </div>
    </div>
  );
};
